export const WEIGHT_OPTIONS = [
  { value: "kg", label: "Kg" },
  { value: "lbs", label: "Lbs" },
];

export const LENGTH_OPTIONS = [
  { value: "cm", label: "Cm" },
  { value: "inch", label: "Inch" },
];

export type DEFAULT_PAYMENT_LOCATION_VALUES_TYPE = {
  location_name: string;

  incoterm_enabled: string;
  incoterm_default_value: string;
  incoterm_visible: boolean;

  addressee: string;
  phone: string;
  address: string;

  approved_invoice_emails: string;

  country_code: string | null;
  city: string;

  city_id: number | null;
  city_name: string;
  country_id: number | null;
  country_name: string;
  state_id: number | null;
  state_name: string;
  zipcode: string | null;

  currency_code: string;
  weight_preference: string;
  length_preference: string;

  freight_modes: Record<string, boolean>;
};

export const DEFAULT_PAYMENT_LOCATION_VALUES: DEFAULT_PAYMENT_LOCATION_VALUES_TYPE = {
  location_name: "",

  incoterm_enabled: "off",
  incoterm_default_value: "None",
  incoterm_visible: false,

  addressee: "",
  phone: "",
  address: "",

  approved_invoice_emails: "",

  country_code: null,
  city: "",

  city_id: null,
  city_name: "",
  country_id: null,
  country_name: "",
  state_id: null,
  state_name: "",
  zipcode: "",

  currency_code: "",
  weight_preference: "",
  length_preference: "",

  freight_modes: {},
};
